<template>

  <aside class="ProductGuideSidebar">

    <div v-for="resource in resourceGroupMenu"
      :key="resource._key"
      class="resource"
      :class="resource.contents && 'currentGuide'"
    >

      <a v-if="resource._type === 'download'"
        :href="resource.url"
        target="_blank"
        class="link"
      >
        {{ resource.title }}
      </a>

      <TableOfContents v-else-if="resource.contents"
        :title="resource.title"
        :contents="resource.contents"
      />

      <a v-else-if="resource.path" :href="resource.path" class="link">
        {{ resource.title }}
      </a>

    </div>

  </aside>

</template>

<script setup>
import TableOfContents from './TableOfContents.vue'

const { resourceGroupMenu } = defineProps({
  resourceGroupMenu: {
    type: Array,
    default: () => [],
  },
})

</script>

<style scoped>

.associatedResources {
  margin-top: var(--spacing-10);
  border-top: thin solid var(--hairline-color);
  padding-top: var(--spacing-10);
}

.resource + .resource {
  margin-top: var(--spacing-2);
}

.resource + .resource.currentGuide {
  margin-top: var(--spacing-10);
}

.resource.currentGuide + .resource {
  margin-top: var(--spacing-10);
  border-top: thin solid var(--hairline-color);
  padding-top: var(--spacing-10);
}

.resource .link {
  transition: color 0.15s;
  font-weight: 600;
  font-size: var(--font-size-2);
}

.resource .link:hover {
  color: var(--brand-color);
}

@media (--screen-lg) {
  .ProductGuideSidebar {
    border-right: thin solid var(--hairline-color);
  }
}
</style>
